import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';

import DateRangetFilter from './DateRangeFilter/DateRangeFilter';

const HeaderActions = ({
  dateFilter,
  onDateFilterChange,
  onResetDateFilter,
  onNextMonth,
  onPreviousMonth,
}) => {
  return (
    <div
      className={clsx(
        'container--header',
        'tw-w-full',
        'tw-sticky tw-top-0 tw-left-0 tw-z-[1]',
        'tw-flex tw-items-center',
        'tw-bg-white',
        'tw-pb-[15px]'
      )}
    >
      <h4 className={clsx('header--title tw-text-[18px] tw-text-cfo-blue-600 tw-mr-[5px]')}>
        Reports for {dateFilter.label}
      </h4>

      <div
        className={clsx(
          'header--actions tw-flex tw-items-center tw-justify-space-between',
          'tw-ml-auto'
        )}
      >
        <Button
          className={clsx(
            'left-arrow tw-leading-none tw-mr-0 tw-p-0',
            dateFilter.isCustom && 'disabled',
            !dateFilter.isCustom && 'hover:tw-text-cfo-blue-600'
          )}
          onClick={onPreviousMonth}
          disabled={dateFilter.isCustom}
        >
          <Icon
            icon={ICONS.arrow_left}
            className={clsx(
              'tw-text-[20px] tw-text-cfo-black',
              dateFilter.isCustom && 'disabled',
              !dateFilter.isCustom && 'hover:tw-text-cfo-blue-600'
            )}
          />
        </Button>
        <Button
          className={clsx('right-arrow tw-leading-none tw-mr-0 tw-p-0')}
          onClick={onNextMonth}
          disabled={dateFilter.isCustom}
        >
          <Icon
            icon={ICONS.arrow_right}
            className={clsx(
              'tw-text-[20px] tw-text-cfo-black',
              !dateFilter.isCustom && 'hover:tw-text-cfo-blue-600'
            )}
          />
        </Button>

        <DateRangetFilter dateFilter={dateFilter} onDateFilterChange={onDateFilterChange} />
        {dateFilter.isCustom && (
          <Button
            className={clsx(
              'button--clear_filter',
              'tw-min-w-[95px] tw-w-full',
              'tw-text-cfo-black tw-font-brandonTextMedium',
              'tw-ml-[20px] tw-p-0',
              'hover:tw-text-cfo-blue-600 hover:tw-underline'
            )}
            onClick={onResetDateFilter}
          >
            <Icon
              icon={ICONS.clear_filter({ className: 'group-hover:tw-fill-cfo-blue-600' })}
              iconType={ICON_TYPES.outlined}
              className={clsx('tw-mr-[5px]')}
            />
            Clear Filters
          </Button>
        )}
      </div>
    </div>
  );
};

export default HeaderActions;
